import { render, staticRenderFns } from "./MatchesListing.vue?vue&type=template&id=5e519f13"
import script from "./MatchesListing.vue?vue&type=script&lang=js"
export * from "./MatchesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports